import { useQuery } from 'react-query';
import adminMeService, { AdminMe } from '../services/adminMe.service';

const ADMIN_ME_QUERY_KEY = ['admin', 'me'] as const;

const useAdminMe = () =>
  useQuery<AdminMe>(ADMIN_ME_QUERY_KEY, () => adminMeService.getMe(), {
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes — permission changes are rare
  });

export default useAdminMe;
